module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "TX1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("BY THE SAME AUTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "I _idGenCharOverride-1"
  }, [_vm._v("Village of Stone")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "I _idGenCharOverride-1"
  }, [_vm._v("A Concise Chinese–English Dictionary for Lovers")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "I _idGenCharOverride-1"
  }, [_vm._v("20 Fragments of a Ravenous Youth")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "I _idGenCharOverride-1"
  }, [_vm._v("UFO in Her Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "I _idGenCharOverride-1"
  }, [_vm._v("Lovers in the Age of Indifference")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "I _idGenCharOverride-1"
  }, [_vm._v("I Am China")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "I _idGenCharOverride-1"
  }, [_vm._v("Once Upon a Time in the East")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Nine Continents")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b189fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97808021495411.vue
// module id = 60
// module chunks = 0